export const COMPANY_NAME = "FuenTales LLC";
export const COMPANY_SHORT = "FuenTales";
export const COMPANY_INITIALS = "F";
export const COMPANY_ADDRESS_FULL = "4802 Golden Sky Way Unit 231, San Diego, California, US 92154-8861";
export const COMPANY_LOCATION = "San Diego, CA";
export const COMPANY_REGION = "San Diego County";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=4802%20Golden%20Sky%20Way%20Unit%20231%2C%20San%20Diego%2C%20California%2C%20US%2092154-8861";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Focus", "value": "Public profile" },
  { "label": "Service Area", "value": "San Diego County" },
  { "label": "Location", "value": "San Diego, CA" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "FuenTales LLC" },
  { "label": "City / State", "value": "San Diego, CA" },
  { "label": "Address", "value": "4802 Golden Sky Way Unit 231, San Diego, California, US 92154-8861" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "TODO: Pillar 1", "body": "TODO: Customize." },
  { "icon": "✦", "title": "TODO: Pillar 2", "body": "TODO: Customize." },
  { "icon": "✿", "title": "TODO: Pillar 3", "body": "TODO: Customize." },
  { "icon": "❍", "title": "TODO: Pillar 4", "body": "TODO: Customize." },
];
